import {
  Button,
  useUpdate,
  useNotify,
  useRedirect,
  useRefresh
} from 'react-admin';
import GppGoodIcon from '@mui/icons-material/GppGood';

const ReactivateDriverButton: React.FC = (props: any) => {
  const [update] = useUpdate();
  const notify = useNotify();
  const redirectTo = useRedirect();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    const values = props.record
    values.active = true
    delete values.metadata
    update('drivers', props.record.id, values, props.record, {
      onSuccess: () => {
        notify('Driver reactivated', 'info', undefined, false, 3000);
        redirectTo(`/drivers/${props.record.id}/show`, props.basePath);
        setTimeout(()=> {refresh(true)}, 1500);
      },
      onFailure: ({ error }) => {
        console.log(error)
        notify(error.message, 'error');
      }
    })
  };

  return (
    <>
      <Button onClick={handleSubmit} label="Reactivate" style={{color: 'green'}}>
        <GppGoodIcon sx={{ color: 'green' }}/>
      </Button>
    </>
  );
}

export default ReactivateDriverButton;

